export default "__VITE_ASSET__YyOi9pT0__"